import http from "Utils/api2";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

/* ===================== ASYNC ACTIONS ===================== */

// Get all brands
export const getBrands = createAsyncThunk("getBrands", async (url) => {
  const res = await http.get(url);
  return res.data;
});

// Get global brands
export const getGlobalBrands = createAsyncThunk(
  "getGlobalBrands",
  async (url) => {
    const res = await http.get(url);
    return res.data;
  }
);

// Get single brand (no API call, just set data)
export const getSingleBrands = createAsyncThunk(
  "getSingleBrands",
  async (data) => {
    return data;
  }
);

// Create brand
export const createBrands = createAsyncThunk(
  "createBrands",
  async ({ url, data }) => {
    const res = await http.post(url, data);
    return res.data;
  }
);

// Update brand
export const updateBrands = createAsyncThunk(
  "updateBrands",
  async ({ url, data }) => {
    const res = await http.put(url, data);
    return res.data;
  }
);

// Disable brand (YOUR PROBLEM API — NOW FIXED)
export const disableBrands = createAsyncThunk(
  "disableBrands",
  async ({ url }) => {
    const res = await http.patch(url); // <-- NO BODY, NO EXTRA HEADERS
    return res.data;
  }
);

// Delete brand
export const deleteBrands = createAsyncThunk(
  "deleteBrands",
  async (url) => {
    const res = await http.delete(url);
    return res.data;
  }
);

/* ===================== SLICE ===================== */

const brandSlice = createSlice({
  name: "brandSlice",
  initialState: {
    brands: null,
    singleBrands: null,
    isPages: null,
    Loading: false,
    IsLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // GET BRANDS
      .addCase(getBrands.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getBrands.fulfilled, (state, action) => {
        state.Loading = false;
        state.brands = action.payload?.data;
        // state.isPages = action.payload?.totalPage;
        state.isPages = action.payload?.pagination?.totalPages || action.payload?.page || action.payload?.totalPage || 1;
      })
      .addCase(getBrands.rejected, (state) => {
        state.Loading = false;
      })

      // GLOBAL BRANDS
      .addCase(getGlobalBrands.fulfilled, (state, action) => {
        state.brands = action.payload?.data;
        // state.isPages = action.payload?.totalPage;
        state.isPages = action.payload?.pagination?.totalPages || action.payload?.page || action.payload?.totalPage || 1;
      })

      // CREATE BRAND
      .addCase(createBrands.pending, (state) => {
        state.Loading = true;
      })
      .addCase(createBrands.fulfilled, (state) => {
        state.Loading = false;
      })
      .addCase(createBrands.rejected, (state) => {
        state.Loading = false;
      })

      // SINGLE BRAND
      .addCase(getSingleBrands.pending, (state) => {
        state.IsLoading = true;
      })
      .addCase(getSingleBrands.fulfilled, (state, action) => {
        state.IsLoading = false;
        state.singleBrands = action.payload;
      })
      .addCase(getSingleBrands.rejected, (state) => {
        state.IsLoading = false;
      });
  },
});

export default brandSlice.reducer;
